<template>
  <el-menu
    :default-active="defActive"
    mode="horizontal"
    background-color="#233c54"
    text-color="#fff"
    active-text-color="#ffd04b"
    class="dw-menu-height dw-menu"
    router
    @select="handleSelect">
    <el-menu-item v-has-dw-role="['SUPER_ADMIN','ENT_ADMIN','DEPT_ADMIN','PROJECT_ADMIN','QT_SURVEY_LIST']" index="/dw/survey" >我的问卷</el-menu-item>
    <el-menu-item index="/dw/task" >我的任务</el-menu-item>
    <el-menu-item v-has-dw-role="['SUPER_ADMIN','ENT_ADMIN','DEPT_ADMIN','PROJECT_ADMIN','QT_TEMPLATER_LIST']" index="/dw/template" >模板中心</el-menu-item>
    <el-menu-item v-has-dw-role="['DWSURVEY_SUPER_ADMIN','SUPER_ADMIN', 'ENT_ADMIN', 'DEPT_ADMIN', 'HT_MANAGER_MENU']" index="/dw/admin/dashboard/analysis" >管理后台</el-menu-item>
  </el-menu>
</template>
<script>

export default {
  name: 'DwNavMenu',
  data () {
    return {
      defActive: '/dw/survey'
    }
  },
  watch: {
    $route: function (to, from) {
      this.setDefActive()
    }
  },
  mounted () {
    this.setDefActive()
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    setDefActive () {
      const fullPath = this.$route.fullPath
      if (fullPath.indexOf('/dw/survey') >= 0) {
        this.defActive = '/dw/survey'
      } else if (fullPath.indexOf('/dw/template') >= 0) {
        this.defActive = '/dw/template'
      } else if (fullPath.indexOf('/dw/user') >= 0) {
        this.defActive = '/dw/user'
      } else if (fullPath.indexOf('dw/task') >= 0) {
        this.defActive = '/dw/task'
      } else if (fullPath.indexOf('/dw/admin') >= 0) {
        this.defActive = '/dw/admin/dashboard/analysis'
      }
    }
  }
}
</script>

<style scoped>
.dw-menu-height,.dw-menu-height>.el-menu-item,.dw-menu-height>.el-submenu /deep/ .el-submenu__title{
  /*height: 80px;*/
  /*line-height: 80px;*/
  font-weight: 400;
  font-size: 16px;
}
.dw-menu{
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwNavMenu.vue